export const getTitle = (isSubAgent: boolean) => {
  return isSubAgent ? 'Риелтор' : 'Агентство недвижимости';
};
